import { MediaType } from '../media-types';
import { expandWithOtherTypes } from '../types-and-exts';

export const handledMediaTypes: ReadonlySet<string> = expandWithOtherTypes([
	// Content
	MediaType.Html,
	MediaType.Xhtml,
	MediaType.Css,
	MediaType.Js,

	// Image
	'image/apng',
	'image/bmp',
	'image/gif',
	'image/x-icon',
	'image/jpeg',
	'image/png',
	'image/svg+xml',
	// 'image/tiff',
	'image/webp',

	// VML
	MediaType.Emf,
	MediaType.Emz,
	MediaType.Wmf,
	MediaType.Wmz,

	// Fonts
	MediaType.Woff,
	MediaType.Woff2,
	MediaType.Ttf,
]);
